// components/ActionButtons.js
import React, {useState} from 'react';
import {Button, Menu, MenuItem} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import DensitySmallIcon from '@mui/icons-material/DensitySmall';
import {handleAddPosition, handleDeleteFromOldGrid} from "@marketwatch/gridcomponents/util/GridOperations";
import {useTickContext} from "../../../contexts/TickContext";
import {useSharingContext} from '../../../contexts/SharingContext';
import {handleShowDetails} from "@marketwatch/gridcomponents/guiinstrumentrow/MoreDetails/MoreDetailsOperations";
import "./ActionButton.css";
import {useInstrumentRowContext} from '../../../contexts/InstrumentRowContext';

const ActionButtons = ({ onShowChart }) => {
    const tickContext = useTickContext();
    const tick = tickContext.tick;
    /*const { changeSubscriptionModeToDetail } = useTickContext();*/
    const { currentlyHeldPositions, setCurrentlyHeldPositions, PosGridlayouts, setPosGridlayouts,PosGridTabID} = useSharingContext();
    const [anchorEl, setAnchorEl] = useState(null);
    const {
        GUIInstrument,
        setGUIInstruments,
        setLayouts,
        tabID,

        index
    } = useInstrumentRowContext();

    const handleClick = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);  // use actual button DOM element
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div className={`actionsSS ${anchorEl ? 'show-actions' : ''}`}>
            <Button variant="contained" color="primary">B</Button>
            <Button variant="contained" color="secondary">S</Button>
            <Button
                variant="contained"
                sx={{backgroundColor: '#4caf50', color: 'white'}}
                onMouseDown={(event) => event.stopPropagation()}
                onClick={() => handleAddPosition(GUIInstrument.instrumentEntity, setLayouts, tabID, tick, setCurrentlyHeldPositions, PosGridlayouts, setPosGridlayouts, PosGridTabID)}
                disabled={currentlyHeldPositions.some(position => position.instrumentToken === GUIInstrument.instrumentEntity.instrumentToken)}  // Disable if instrumentToken is in currentlyHeldPositions
            >
                P
            </Button>
            <Button
                variant="contained"
                color="white"
                className="small-button density-icon"
                onMouseDown={(event) => event.stopPropagation()}
                onClick={() => handleShowDetails(GUIInstrument.instrumentEntity, setGUIInstruments, setLayouts, tabID, index)}
            >
                <DensitySmallIcon sx={{fontSize: 16}}/>
            </Button>
            <Button
                variant="contained"
                color="default"
                onMouseDown={(event) => event.stopPropagation()}
                onClick={() => handleDeleteFromOldGrid( GUIInstrument.instrumentEntity, setGUIInstruments, setLayouts, tabID)}
            >
                <DeleteIcon sx={{color: '#ff4d4d'}}/>
            </Button>
            <Button
                variant="contained"
                color="default"
                className="small-button"
                onMouseDown={(event) => event.stopPropagation()}
                onClick={handleClick}
            >
                <MoreHorizIcon sx={{fontSize: 22}}/>
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                keepMounted
            >
                <MenuItem onClick={(e) => {
                    e.currentTarget.blur(); // ✅ Remove focus from menu item to prevent aria-hidden trap
                    onShowChart(GUIInstrument.instrumentEntity.instrumentToken,GUIInstrument.instrumentEntity.tradingsymbol);
                    handleClose();
                }}>
                    Chart
                </MenuItem>

            </Menu>
        </div>
    );
};

export default ActionButtons;